"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const react_dropzone_1 = require("react-dropzone");
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Movie_1 = __importDefault(require("@material-ui/icons/Movie"));
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const styles_1 = require("@material-ui/core/styles");
const TGRadioFieldWeb_1 = __importDefault(require("./TGRadioFieldWeb"));
const common_1 = require("../../utils/common");
const lodash_1 = __importDefault(require("lodash"));
const FieldHeader_1 = __importStar(require("./FieldHeader"));
const DialogWrapperWeb_1 = __importDefault(require("../Common/DialogWrapperWeb"));
const uuid_1 = require("uuid");
const CommonWeb_1 = require("./CommonWeb");
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const theme_1 = require("../../styles/theme");
var Capture;
(function (Capture) {
    Capture["UPLOAD"] = "0";
    Capture["DEVICE_CAMERA"] = "1";
})(Capture || (Capture = {}));
var CameraOptions;
(function (CameraOptions) {
    CameraOptions["SYSTEM_CAMERA"] = "1";
})(CameraOptions || (CameraOptions = {}));
const CaptureArea = props => {
    const { captureLabel, fileUploadLabel, deviceUploadLabel, captureType, setCaptureType, camera, setCamera, translateFunction = text => text } = props, moreProps = __rest(props, ["captureLabel", "fileUploadLabel", "deviceUploadLabel", "captureType", "setCaptureType", "camera", "setCamera", "translateFunction"]);
    const captureAreaStyles = useCaptureAreaStyles();
    return (react_1.default.createElement("div", { className: captureAreaStyles.container },
        react_1.default.createElement(TGRadioFieldWeb_1.default, { label: captureLabel, options: [
                {
                    value: Capture.UPLOAD,
                    label: translateFunction(fileUploadLabel),
                },
                {
                    value: Capture.DEVICE_CAMERA,
                    label: translateFunction(deviceUploadLabel),
                },
            ], defaultValue: Capture.UPLOAD, onChange: (x) => setCaptureType(x.target.value), translateFunction: translateFunction }),
        captureType === Capture.DEVICE_CAMERA && (react_1.default.createElement(TGRadioFieldWeb_1.default, { value: camera, className: captureAreaStyles.dropdown, label: 'Select Camera', options: [
                {
                    value: CameraOptions.SYSTEM_CAMERA,
                    label: translateFunction('System camera'),
                },
            ], onChange: (evt) => {
                setCamera(evt.target.value);
            }, translateFunction: translateFunction }))));
};
const useCaptureAreaStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    dropdown: {
        width: '250px',
        marginBottom: '20px',
    },
    container: {
        marginBottom: 20,
    },
}));
const UploadCount = props => {
    const { min, max, length, readOnly, translateFunction = text => text } = props, moreProps = __rest(props, ["min", "max", "length", "readOnly", "translateFunction"]);
    const uploadCountStyles = useUploadCountStyles();
    return (react_1.default.createElement("div", { className: uploadCountStyles.container },
        react_1.default.createElement(core_1.Typography, { className: readOnly ? (0, clsx_1.default)(uploadCountStyles.texts, uploadCountStyles.lastChild) : uploadCountStyles.texts, display: "inline" },
            react_1.default.createElement("span", { className: uploadCountStyles.addedText },
                `${translateFunction('$__LENGTH__$ added', { LENGTH: length })}`,
                " ")),
        !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { className: uploadCountStyles.texts },
                react_1.default.createElement("span", { className: uploadCountStyles.requiredText }, translateFunction('Required')),
                react_1.default.createElement("span", { className: uploadCountStyles.symbolText }, `: ${min}`)),
            react_1.default.createElement(core_1.Typography, { className: (0, clsx_1.default)(uploadCountStyles.texts, uploadCountStyles.lastChild) },
                react_1.default.createElement("span", { className: uploadCountStyles.requiredText }, translateFunction('Allowed')),
                react_1.default.createElement("span", { className: uploadCountStyles.symbolText }, `: ${max > -1 ? max : translateFunction('unlimited')}`))))));
};
const useUploadCountStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    texts: {
        display: 'inline-flex',
        marginRight: 10,
    },
    lastChild: {
        marginRight: 0,
    },
    container: {
        height: 19,
    },
    requiredText: {
        color: theme_1.colors.black54,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
    },
    symbolText: {
        color: theme_1.colors.black54,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
    numberText: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: 'normal',
    },
    addedText: {
        color: theme_1.colors.black54,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
}));
const DropZone = props => {
    const { dragLabel, allowedTypes, updateFileList, error, mediaType, translateFunction = text => text } = props, moreProps = __rest(props, ["dragLabel", "allowedTypes", "updateFileList", "error", "mediaType", "translateFunction"]);
    const extensions = (0, common_1.useExtensions)(allowedTypes, ',');
    const extensionsLabel = (0, common_1.useExtensions)(allowedTypes, ' | ');
    const dropZoneStyles = useDropzoneStyles();
    const { getRootProps, getInputProps, isDragActive } = (0, react_dropzone_1.useDropzone)({ onDrop: updateFileList, noClick: true });
    let icon = react_1.default.createElement(AddPhotoAlternate_1.default, null);
    if (mediaType === 'video' || mediaType === 'audio')
        icon = react_1.default.createElement(Movie_1.default, null);
    return (react_1.default.createElement("div", Object.assign({ className: (0, clsx_1.default)(dropZoneStyles.fileuploader, isDragActive && dropZoneStyles.dragActive) }, getRootProps()),
        react_1.default.createElement("div", { id: "upload-label", style: styles.dropZoneContainer },
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "81", height: "50", viewBox: "0 0 81 50", fill: "none" },
                react_1.default.createElement("path", { d: "M65.3063 18.6391C63.0112 8.11084 52.785 0.207031 40.5 0.207031C30.7463 0.207031 22.275 5.21176 18.0562 12.5357C7.8975 13.5123 0 21.294 0 30.7236C0 40.8246 9.07875 49.0336 20.25 49.0336H64.125C73.44 49.0336 81 42.1979 81 33.7753C81 25.7189 74.0813 19.1884 65.3063 18.6391ZM47.25 27.672V39.8786H33.75V27.672H23.625L40.5 12.4137L57.375 27.672H47.25Z", fill: "black", "fill-opacity": "0.25" }))),
        react_1.default.createElement("div", { style: styles.dropZoneContent },
            react_1.default.createElement(core_1.Typography, { className: [dropZoneStyles.title, dropZoneStyles.titleColor].join(' ') }, translateFunction(dragLabel)),
            react_1.default.createElement(core_1.Typography, { className: [dropZoneStyles.title, dropZoneStyles.orText].join(' ') }, translateFunction('or')),
            react_1.default.createElement("input", Object.assign({}, getInputProps(), { accept: extensions, style: styles.none, id: "contained-button-file", onChange: (evt) => {
                    const files = lodash_1.default.get(evt, 'target.files');
                    updateFileList(files);
                }, multiple: true, type: "file" })),
            react_1.default.createElement("label", { htmlFor: "contained-button-file" },
                react_1.default.createElement(core_1.Button, { variant: "contained", color: "default", className: dropZoneStyles.uploadbtn, startIcon: icon, component: "span" }, translateFunction('Upload'))),
            react_1.default.createElement(core_1.Typography, { className: (0, clsx_1.default)(dropZoneStyles.title, dropZoneStyles.formats) }, translateFunction(extensionsLabel)),
            error && react_1.default.createElement(core_1.Typography, { className: dropZoneStyles.errorText }, translateFunction(error)))));
};
const useDropzoneStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    fileuploader: {
        padding: '43.206px 129px 42.968px 128px',
        border: `1px dashed ${theme_1.colors.black35}`,
        background: theme_1.colors.lotion,
        marginTop: 10,
        borderRadius: 6,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            padding: '43px 50px',
        },
    },
    dragActive: {
        border: `4px dashed ${theme.palette.primary.main}`,
    },
    title: {
        position: 'relative',
        textAlign: 'center',
        lineHeight: 'normal',
    },
    titleColor: {
        color: theme_1.colors.black54,
        fontWeight: 300,
        fontSize: 20,
    },
    orText: {
        padding: '14px 0px',
        color: theme_1.colors.dimGray,
        fontSize: 16,
        fontWeight: 300,
    },
    uploadbtn: {
        lineHeight: 'normal',
        marginBottom: 12,
        color: theme_1.colors.black0,
        boxShadow: `0px 2px 4px 0px ${theme_1.colors.black15}`,
        borderRadius: 5,
        '&:hover': {
            boxShadow: `0px 2px 4px 0px ${theme_1.colors.black15}`,
        },
    },
    formats: {
        fontSize: '14px',
        fontWeight: 300,
        color: 'rgba(0, 0, 0, 0.35)',
        lineHeight: 'normal',
    },
    errorText: {
        color: theme_1.colors.danger,
        position: 'relative',
        textAlign: 'center',
        marginTop: '30px',
    },
}));
const useMediaFieldStyles = (0, styles_1.makeStyles)({
    content: {
        padding: '22px 34px',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: `calc(100% - ${FieldHeader_1.FIELD_HEADER_HEIGHT}px)`,
        overflowY: 'auto',
        boxSizing: 'border-box',
    },
    deleteIconBtn: { color: theme_1.colors.dangerFontColor, padding: 5, width: 17, height: 17 },
    formControlElement: {
        height: '100%',
        width: '100%',
    },
    innerContainer: {
        marginTop: 10,
    },
});
const TGMediaFileField = props => {
    const { addFiles, removeFiles, toggleModal, files } = props;
    const [captureType, setCaptureType] = (0, react_1.useState)(Capture.UPLOAD);
    const [uploadError, setUploadError] = (0, react_1.useState)(null);
    const [fileList, setFileList] = (0, react_1.useState)(files || []);
    const [addedFiles, setAddedFiles] = (0, react_1.useState)([]);
    const [removedFiles, setRemovedFiles] = (0, react_1.useState)([]);
    const [camera, setCamera] = (0, react_1.useState)(CameraOptions.SYSTEM_CAMERA);
    const classes = useMediaFieldStyles();
    const Deleteclasses = (0, CommonWeb_1.useStyles)();
    const onDonePress = () => {
        addFiles(fileList.filter((x) => addedFiles.find(item => item.id === x.id)));
        removeFiles(removedFiles);
        toggleModal && toggleModal();
    };
    const onDeleteFile = (id) => {
        setFileList(fileList.filter(x => x.id !== id));
        setRemovedFiles([...removedFiles, id]);
    };
    const onCancelPress = () => {
        toggleModal && toggleModal();
    };
    const { label, captureLabel, fileUploadLabel, deviceUploadLabel, dragLabel, allowedTypes, limitInMb, min, max, renderMedia, mediaType, translateFunction = text => text } = props, moreProps = __rest(props, ["label", "captureLabel", "fileUploadLabel", "deviceUploadLabel", "dragLabel", "allowedTypes", "limitInMb", "min", "max", "renderMedia", "mediaType", "translateFunction"]);
    const isValidLimit = (size) => size / 1024 / 1024 <= limitInMb;
    const addFileToList = (file) => {
        updateFileList([file]);
    };
    const updateFileList = (fileObjects) => {
        if (fileObjects && fileObjects.length) {
            const files = [...fileObjects];
            if (!files.every(file => isValidLimit(file.size))) {
                setUploadError(translateFunction('Oops, the selected file is over the $__LIMIT__$ mb limit. Please choose a smaller file', {
                    LIMIT: limitInMb,
                }));
                return;
            }
            setUploadError(null);
            const list = files.map((file) => {
                const splitPath = file.name.split('.');
                const extension = splitPath[splitPath.length - 1];
                return {
                    id: `${(0, uuid_1.v4)()}.${extension}`,
                    file: file,
                    url: URL.createObjectURL(file),
                };
            });
            setFileList([...fileList, ...list]);
            setAddedFiles([...addedFiles, ...list.map(x => ({ id: x.id, name: x.file.name }))]);
        }
    };
    return (react_1.default.createElement(core_1.FormControl, { className: classes.formControlElement },
        react_1.default.createElement(FieldHeader_1.default, { title: label, canSave: true, onDonePress: onDonePress, onCancelPress: onCancelPress, canSaveActive: !!fileList.length, doneButtonText: 'Add', cancelButtonText: 'Cancel', translateFunction: translateFunction }),
        react_1.default.createElement(core_1.Box, { pt: 3, className: classes.content },
            react_1.default.createElement(CaptureArea, { captureLabel: captureLabel, fileUploadLabel: fileUploadLabel, deviceUploadLabel: deviceUploadLabel, captureType: captureType, setCaptureType: setCaptureType, camera: camera, setCamera: setCamera, translateFunction: translateFunction }),
            react_1.default.createElement(UploadCount, { max: max, min: min, length: fileList.length, translateFunction: translateFunction }),
            captureType === Capture.DEVICE_CAMERA && camera === CameraOptions.SYSTEM_CAMERA ? (renderMedia && renderMedia(addFileToList)) : (react_1.default.createElement(DropZone, { dragLabel: dragLabel, allowedTypes: allowedTypes, updateFileList: updateFileList, error: uploadError, mediaType: mediaType, translateFunction: translateFunction })),
            react_1.default.createElement("div", { className: Deleteclasses.uploadfiles }, !!fileList.length &&
                fileList.map(file => {
                    var _a;
                    return (react_1.default.createElement("div", { className: Deleteclasses.innerContainer },
                        react_1.default.createElement("span", { className: Deleteclasses.uploadList }, (_a = file.file) === null || _a === void 0 ? void 0 : _a.name),
                        react_1.default.createElement(core_1.IconButton, { className: classes.deleteIconBtn, component: "span", onClick: (e) => {
                                e.stopPropagation();
                                onDeleteFile(file.id);
                            } },
                            react_1.default.createElement(Delete_1.default, null))));
                })))));
};
const DefaultView = props => {
    const { min, max, removeFiles, files, readOnly, warning, translateFunction = text => text } = props, moreProps = __rest(props, ["min", "max", "removeFiles", "files", "readOnly", "warning", "translateFunction"]);
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    const classes = (0, CommonWeb_1.useStyles)();
    return (react_1.default.createElement("div", { onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) },
        react_1.default.createElement(DialogWrapperWeb_1.default, Object.assign({}, props, { clearValue: () => removeFiles(files.map(file => file.id)), position: 'bottom', renderHeader: () => {
                return (react_1.default.createElement("div", { className: classes.mediaInput },
                    react_1.default.createElement(core_1.InputLabel, { error: props.error, className: (0, clsx_1.default)(warning && classes.warningText) },
                        react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip, error: props.error, style: classes.labelWrapper, translateFunction: translateFunction })),
                    react_1.default.createElement(UploadCount, { min: min, max: max, length: files.length, readOnly: readOnly, translateFunction: translateFunction })));
            }, renderMiddleValue: () => {
                return (react_1.default.createElement("div", { className: classes.imageCountText }, translateFunction('$__FILES__$ File(s) Added', { FILES: files.length })));
            }, renderValue: () => {
                return (react_1.default.createElement("div", { className: classes.uploadfiles },
                    !!files.length &&
                        files.map(file => {
                            var _a;
                            return (react_1.default.createElement("div", { className: classes.innerContainer },
                                react_1.default.createElement("span", { className: classes.uploadList }, file.name || ((_a = file.file) === null || _a === void 0 ? void 0 : _a.name)),
                                react_1.default.createElement(core_1.IconButton, { className: classes.deleteIconBtn, component: "span", onClick: (e) => {
                                        e.stopPropagation();
                                        removeFiles([file.id]);
                                    } },
                                    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "17", viewBox: "0 0 17 17", fill: "none" },
                                        react_1.default.createElement("path", { d: "M4.25033 13.4583C4.25033 14.2375 4.88783 14.875 5.66699 14.875H11.3337C12.1128 14.875 12.7503 14.2375 12.7503 13.4583V4.95833H4.25033V13.4583ZM13.4587 2.83333H10.9795L10.2712 2.125H6.72949L6.02116 2.83333H3.54199V4.25H13.4587V2.83333Z", fill: "#FF1616" })))));
                        }),
                    react_1.default.createElement(core_1.FormHelperText, { error: props.error, className: (0, clsx_1.default)(warning && classes.warningText) }, translateFunction(props.helperText))));
            }, renderComponent: toggleModal => {
                return react_1.default.createElement(TGMediaFileField, Object.assign({}, props, { toggleModal: toggleModal }));
            } }))));
};
const styles = {
    uploadCountContainer: {
        marginTop: 8,
    },
    dropZoneContainer: {
        width: '200px',
        margin: 'auto',
        textAlign: 'center',
    },
    dropZoneContent: {
        width: '100%',
        margin: 'auto',
        textAlign: 'center',
    },
    none: {
        display: 'none',
    },
};
exports.default = DefaultView;
//# sourceMappingURL=TGMediaFileFieldWeb.js.map